import Interaction from "../../../models/interactions/Interaction";
import PiButton from "../../../components/PiButton";
import VariableSelector from "../variables/VariableSelector";
import SwitchCaseNodePreview from "./SwitchCaseNodePreview";
import SwitchDefaultNodePreview from "./SwitchDefaultNodePreview";
import useSwitchNodePreview from "./useSwitchNodePreview.hook";

export default function SwitchNodePreview(props: {
  nodeId: string;
  interaction: Interaction;
}) {
  const {
    switchNode,
    variables,
    variableType,
    handleVariableSelect,
    updateCase,
    handleAddCase,
    handleDeleteCase,
  } = useSwitchNodePreview(props.nodeId, props.interaction);
  const canDeleteCase = switchNode.cases.length > 1;

  return (
    <div className="w-full h-full flex flex-col gap-[12px] pb-[24px]">
      <style>{`
        .switch-case-handle.react-flow__handle-right:hover {
          transform: translateY(-50%) scale(1.3) !important;
        }
      `}</style>
      <VariableSelector
        variables={variables}
        selectedVariableId={switchNode.variable}
        label="Variable"
        onSelect={handleVariableSelect}
      />
      <div className="flex flex-col gap-[12px]">
        {switchNode.cases.map((caseItem) => (
          <SwitchCaseNodePreview
            key={caseItem.id}
            nodeId={props.nodeId}
            caseItem={caseItem}
            variableType={variableType}
            onChange={updateCase}
            onDelete={() => handleDeleteCase(caseItem.id)}
            canDelete={canDeleteCase}
          />
        ))}
      </div>
      <SwitchDefaultNodePreview nodeId={props.nodeId} />
      <div className="h-[36px]">
        <PiButton variant="piBlueOutlined" onClick={handleAddCase}>
          + Add Case
        </PiButton>
      </div>
    </div>
  );
}
